import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import TourTicketDetail from './TourTicketDetail';
import * as tourActions from './../../../../../../../../actions/tourAction';
import * as objectTypeActions from './../../../../../../../../actions/objectTypeAction';
import * as RateCodeAction from './../../../../../../../../actions/rateCodeAction';
import { getAllTourPropertyAction } from './../../../../../../../../actions/propertyAction';

const mapStateToProps = state => {
    return {
        tourState: state.tourReducer,
        property: state.propertyReducer,
        objectTypeState: state.objectTypeReducer,
        rateCodeState: state.rateCodeReducer,
        autoTranslateState: state.autoTranslateReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onCreateTourTicket: (tourTicket, copy) => dispatch(tourActions.createDetailTourTicketAction(tourTicket, copy)),
        onUpdateTourTicket: (tourTicket) => dispatch(tourActions.updateDetailTourTicketAction(tourTicket)),
        onGetUpdate: (id) => dispatch(tourActions.getDetailTourTicketDetailAction(id)),
        createTourTicketTranslate: (tourTicket, language) => dispatch(tourActions.createDetailTourTicketTranslate(tourTicket, language)),
        updateTourTicketTranslate: (tourTicket, language) => dispatch(tourActions.updateDetailTourTicketTranslate(tourTicket, language)),
        deleteTourTicketTranslate: (tourTicket, refreshParams) => dispatch(tourActions.deleteDetailTourTicketTranslate(tourTicket, refreshParams)),
        onListAllProperties: () => dispatch(getAllTourPropertyAction()),
        getAllObjectType: (params) => dispatch(objectTypeActions.getAllObjectType(params)),
        getTourDetail: (tourId) => dispatch(tourActions.getTourDetail(tourId)),
        getRateCodeListAll: (params) => dispatch(RateCodeAction.getRateCodeListAll(params)),
        getRateCodeListWithPaging: (params, payload) => dispatch(RateCodeAction.getRateCodeListWithPaging(params, payload)),
        getRateCodeDetailCache: (id, payload) => dispatch(RateCodeAction.getRateCodeDetailCache(id, payload)),


        //TOUR TYPES
        getAllSurchargeCategories: () => dispatch(tourActions.getAllSurchargeCategories()),
        createSurchargeCategories: (surchargeCategories) => dispatch(tourActions.createSurchargeCategories(surchargeCategories)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TourTicketDetail));
